import HCheckArray from "@rf-helper/check-have-value";
import useAlert from "@rf-hooks/useAlert";
import { useFormContext } from "react-hook-form";

const useValidateSeoFieldHasValue = (fields: string[]) => {
  const { getValues } = useFormContext();
  const { alert } = useAlert();
  const evaluateAndConfirmFieldReplacement = (stringMessage?: string) => {
    const test = fields.some(value => {
      const item = getValues(value);
      if (typeof item === "string") {
        return item != "";
      } else if (Array.isArray(item)) {
        return HCheckArray(item);
      } else {
        return false;
      }
    });

    return new Promise<boolean>((resolve, reject) => {
      if (test) {
        alert({
          title: "Reemplazo de información",
          color: "warning.main",
          message:
            stringMessage ||
            "Al generar el título y la descripción con ChatGPT, la información colocada se perderá. ¿Desea continuar?",
          type: "warning",
          confirmBtnMessage: "Si",
          declineBtnMessage: "No"
        }).then(result => {
          if (result.type.confirm) {
            resolve(true);
          } else {
            resolve(false);
          }
        });
      } else {
        resolve(true);
      }
    });
  };

  return {
    evaluateAndConfirmFieldReplacement
  };
};

export default useValidateSeoFieldHasValue;
